import { ServiceSchema } from "@redotech/redo-fulfillment-carrier-common/carrier-service-catalog";
import { CarrierSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import { LengthUnitSchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import * as z from "zod";

const weightInputSchema = z.object({ lbs: z.number() });

// Optional. When omitted, the quote is weight-only, exactly as before.
const dimensionsInputSchema = z.object({
  length: z.number(),
  width: z.number(),
  height: z.number(),
  unit: LengthUnitSchema,
});

const rateCalculatorInputSchema = z.object({
  mode: z.literal("simple"),
  originZip: z.string(),
  originCountry: z.string(),
  destinationZip: z.string(),
  destinationCountry: z.string(),
  destinationCity: z.string().optional(),
  destinationState: z.string().optional(),
  weight: weightInputSchema,
  dimensions: dimensionsInputSchema.optional(),
});

const rateCalculatorRateSchema = z.object({
  carrier: CarrierSchema,
  service: ServiceSchema,
  rate: z.string(),
  currency: z.string(),
  delivery_days: z.number().nullish(),
  delivery_date: z.string().nullish(),
  delivery_date_guaranteed: z.boolean().nullish(),
  provider: z.string(),
  is_merchant_carrier_account: z.boolean().nullish(),
});

export interface RateCalculatorRate extends z.infer<
  typeof rateCalculatorRateSchema
> {}

const messageSchema = z.object({
  carrier: z.string().optional(),
  message: z.string().optional(),
});

export const getRateCalculatorRates = {
  name: "getRateCalculatorRates" as const,
  input: rateCalculatorInputSchema,
  output: z.object({
    rates: z.array(rateCalculatorRateSchema),
    messages: z.array(messageSchema),
  }),
};
